// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Images_Table {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 4px 16px rgba(172, 124, 98, 0.05);
    border-radius: 8px;
    padding: 4%;
}

.image_checkbox {
    visibility: hidden;
    position: absolute;
    top: 10px;
    left: 10px;
}

.Alert_Image>img{
    height: 30vh !important;
    width: 100% !important;
}
.Alert_Image{
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.Images_Controllers {
    visibility: hidden;
    display: flex;
    position: absolute;
    gap: 12px;
    top: 100px;
    width: 100%;
    align-items: center;
    justify-content: center;
}

.Images_Controllers img {
    cursor: pointer;
}

.Individual_Image:hover .Images_Controllers,.Individual_Image:hover .image_checkbox {
    visibility: visible !important;
}




.Images_View {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    height: 65vh;
    overflow-y: scroll;
    margin-top: 10px;
    -ms-overflow-style: none;
    scrollbar-width: none;
    justify-content: center;
}



.viewControls:hover .image_controls{
    visibility: visible !important;
    cursor: pointer;
}

.Images_View::-webkit-scrollbar {
    display: none;
}


.Individual_Image {
    width: 192px;
    height: 144px;
    border-radius: 8px;
}

.Individual_Image>img {
    width: 100%;
    cursor: pointer;
    height: 100%;
    border-radius: 8px;
}

.uploadimagdesc {
    display: flex;
    flex-direction: column;
    margin-top: 8px;
}

.uploadimagdesc span {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #594F42;
}

.ImageName>span {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #594F42
}

.Image_Edit_View {
    padding: 32px;
    border-right: 1px solid rgb(232, 223, 213, .5);
}

.Image_Edit_View>img {
    width: 642px;
    height: 526px;
    border-radius: 8px;
}

.Image_Edit_Mode {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 4px 16px rgba(172, 124, 98, 0.05);
    border-radius: 8px;
    display: flex;
    margin-top: 10px;
}


.Image_Edit_Data {
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 40px;
}

.Setting_User_Attribute>img {
    cursor: pointer;
}

.BasicDetails {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.BasicHeader {
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    color: #3F3325;
}

.GeolocationHeader {
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    color: #3F3325;
}


.BasicDetailEditField>label {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #594F42;
}
.BasicDetailEditField>span{
    font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 20px;
/* identical to box height, or 143% */


/* Tadoba/Text/High Emphasis */

color: #3F3325;
}

.BasicDetailEditField>input {
    border: 1px solid #E8DFD5;
    border-radius: 8px;
    height: 40px;
}

.GeolocationDetails {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.BasicDetailsEditContent {
    display: flex;
    gap: 16px;
}


.GeolocationDetailsEditContent {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
}

.BasicDetailEditField {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 200px;
}

.edit_button {
    width: 84px;
    height: 40px;
    left: 1036px;
    top: 9px;
    cursor: pointer;
    background: rgba(72, 136, 123, 0.2);
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 16px;
    gap: 10px;
}

.edit_button>span {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #38514C;
}

.revert_button{
    background-color: #febcba;
    color: white;
    font-size: 2.5vh;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5vw;
    width: 12vw;
    padding: 1vh 1vw;
    height: 40px;
    cursor: pointer;
    border-radius: 8px;
}

.revert_button>span{
    font-size: 0.8rem;
}

.Alert_Edit_Image>img{
    height: 30vh;
    width: 100%;
    border-radius: 8px;
}
.EditHeadBar{
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
}
.EditHeadBar>span {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #9A938A;
}

.ViewSwitcher{
    display: flex;
    border: 1px solid #E8DFD5;
    border-radius: 6px;
    cursor:pointer;
}

.group_tiger_revert_btn{
    background-color: white;
    padding: 0.5vh 0.4vw;
    font-size: 0.7rem;
    border-radius: 0.3vw;
}


.icons-animation{
    transition: background-color 0.3s ease, transform 0.3s ease, color 0.3s ease;
}
.icons-animation:hover{
    transform: scale(0.80);
}

.icons-animation-scale{
    transition: background-color 0.3s ease, transform 0.3s ease, color 0.3s ease;
}
.icons-animation-scale:hover{
    transform: scale(1.10); 
}

.edit-close-popup{
    font-size: 4vh;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.edit-close-popup:hover{
    fill:#E67817; 
}


.carousel-btn {
    cursor: pointer;
    display: flex;
    font-size: 2rem;
    padding: 0.2rem;
    justify-content: space-between;
  }
  
  .carousel-btn.left {
    border: none;
    font-weight: 600;
    padding: 0.5rem;
    background-color: transparent;
  }
  
  .carousel-btn.right {
    border: none;
    font-weight: 600;
    padding: 0.5rem;
    background-color: transparent;
  }
  
  .carousel-btn:hover {
    color: #E67817; 
  }
  
  .carousel-btn:focus {
    outline: none; 
  }
  
  .group_tiger_revert_btn{
    background-color: white;
    padding: 0.5vh 0.4vw;
    font-size: 0.7rem;
    border-radius: 0.3vw;
}


/** Unidentified **/
.unidentified-back{
    font-size: 1.5rem;
    font-weight: 900;
    cursor: pointer;
}
.scrollable-container {
  max-height: 80vh;
  min-height: 70vh;
  overflow-y: auto;
  padding: 1rem;
  position: relative;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 2vw;
}

.image-folder {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 1rem;
  background-color: #f9f9f9;
  cursor: pointer;
}

.image-folder {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 1rem;
  background-color: #f9f9f9;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.image-folder:hover {
  background-color: #FFF2E7;
  border-color: #FF8214;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.folder-title {
  margin-top: 0.5rem;
  font-weight: bold;
}

.folder-count {
  font-size: 0.85rem;
  color: #666;
}

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 50vh;
}

.spinner {
  border: 6px solid #f3f3f3;
  border-top: 6px solid #FF8214;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


.load-more-btn {
  background-color: #FF8214;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 0.8rem;
  font-weight: bold;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: transform 0.2s ease, background-color 0.3s ease;
}

.load-more-btn:hover:not(:disabled) {
  background-color: #e57110;
  transform: scale(1.03);
}

.load-more-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/CSS/Images.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;IACnB,iDAAiD;IACjD,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;;;;AAKA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;AAC3B;;;;AAIA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,iDAAiD;IACjD,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;;AAGA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,qCAAqC;;;AAGrC,8BAA8B;;AAE9B,cAAc;AACd;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;;AAGA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,eAAe;IACf,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;AACxB;;;AAGA;IACI,4EAA4E;AAChF;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,4EAA4E;AAChF;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,eAAe;IACf,aAAa;IACb,eAAe;IACf,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;AACxB;;;AAGA,mBAAmB;AACnB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".Images_Table {\n    width: 100%;\n    background: #FFFFFF;\n    box-shadow: 0px 4px 16px rgba(172, 124, 98, 0.05);\n    border-radius: 8px;\n    padding: 4%;\n}\n\n.image_checkbox {\n    visibility: hidden;\n    position: absolute;\n    top: 10px;\n    left: 10px;\n}\n\n.Alert_Image>img{\n    height: 30vh !important;\n    width: 100% !important;\n}\n.Alert_Image{\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.Images_Controllers {\n    visibility: hidden;\n    display: flex;\n    position: absolute;\n    gap: 12px;\n    top: 100px;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n}\n\n.Images_Controllers img {\n    cursor: pointer;\n}\n\n.Individual_Image:hover .Images_Controllers,.Individual_Image:hover .image_checkbox {\n    visibility: visible !important;\n}\n\n\n\n\n.Images_View {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 24px;\n    height: 65vh;\n    overflow-y: scroll;\n    margin-top: 10px;\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n    justify-content: center;\n}\n\n\n\n.viewControls:hover .image_controls{\n    visibility: visible !important;\n    cursor: pointer;\n}\n\n.Images_View::-webkit-scrollbar {\n    display: none;\n}\n\n\n.Individual_Image {\n    width: 192px;\n    height: 144px;\n    border-radius: 8px;\n}\n\n.Individual_Image>img {\n    width: 100%;\n    cursor: pointer;\n    height: 100%;\n    border-radius: 8px;\n}\n\n.uploadimagdesc {\n    display: flex;\n    flex-direction: column;\n    margin-top: 8px;\n}\n\n.uploadimagdesc span {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    text-align: center;\n    color: #594F42;\n}\n\n.ImageName>span {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n    color: #594F42\n}\n\n.Image_Edit_View {\n    padding: 32px;\n    border-right: 1px solid rgb(232, 223, 213, .5);\n}\n\n.Image_Edit_View>img {\n    width: 642px;\n    height: 526px;\n    border-radius: 8px;\n}\n\n.Image_Edit_Mode {\n    width: 100%;\n    background: #FFFFFF;\n    box-shadow: 0px 4px 16px rgba(172, 124, 98, 0.05);\n    border-radius: 8px;\n    display: flex;\n    margin-top: 10px;\n}\n\n\n.Image_Edit_Data {\n    padding: 32px;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n}\n\n.Setting_User_Attribute>img {\n    cursor: pointer;\n}\n\n.BasicDetails {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.BasicHeader {\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 28px;\n    color: #3F3325;\n}\n\n.GeolocationHeader {\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 28px;\n    color: #3F3325;\n}\n\n\n.BasicDetailEditField>label {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #594F42;\n}\n.BasicDetailEditField>span{\n    font-style: normal;\nfont-weight: 400;\nfont-size: 14px;\nline-height: 20px;\n/* identical to box height, or 143% */\n\n\n/* Tadoba/Text/High Emphasis */\n\ncolor: #3F3325;\n}\n\n.BasicDetailEditField>input {\n    border: 1px solid #E8DFD5;\n    border-radius: 8px;\n    height: 40px;\n}\n\n.GeolocationDetails {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.BasicDetailsEditContent {\n    display: flex;\n    gap: 16px;\n}\n\n\n.GeolocationDetailsEditContent {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n}\n\n.BasicDetailEditField {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    width: 200px;\n}\n\n.edit_button {\n    width: 84px;\n    height: 40px;\n    left: 1036px;\n    top: 9px;\n    cursor: pointer;\n    background: rgba(72, 136, 123, 0.2);\n    border-radius: 8px;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 10px 16px;\n    gap: 10px;\n}\n\n.edit_button>span {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    display: flex;\n    align-items: center;\n    color: #38514C;\n}\n\n.revert_button{\n    background-color: #febcba;\n    color: white;\n    font-size: 2.5vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5vw;\n    width: 12vw;\n    padding: 1vh 1vw;\n    height: 40px;\n    cursor: pointer;\n    border-radius: 8px;\n}\n\n.revert_button>span{\n    font-size: 0.8rem;\n}\n\n.Alert_Edit_Image>img{\n    height: 30vh;\n    width: 100%;\n    border-radius: 8px;\n}\n.EditHeadBar{\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    cursor: pointer;\n}\n.EditHeadBar>span {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 18px;\n    color: #9A938A;\n}\n\n.ViewSwitcher{\n    display: flex;\n    border: 1px solid #E8DFD5;\n    border-radius: 6px;\n    cursor:pointer;\n}\n\n.group_tiger_revert_btn{\n    background-color: white;\n    padding: 0.5vh 0.4vw;\n    font-size: 0.7rem;\n    border-radius: 0.3vw;\n}\n\n\n.icons-animation{\n    transition: background-color 0.3s ease, transform 0.3s ease, color 0.3s ease;\n}\n.icons-animation:hover{\n    transform: scale(0.80);\n}\n\n.icons-animation-scale{\n    transition: background-color 0.3s ease, transform 0.3s ease, color 0.3s ease;\n}\n.icons-animation-scale:hover{\n    transform: scale(1.10); \n}\n\n.edit-close-popup{\n    font-size: 4vh;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.edit-close-popup:hover{\n    fill:#E67817; \n}\n\n\n.carousel-btn {\n    cursor: pointer;\n    display: flex;\n    font-size: 2rem;\n    padding: 0.2rem;\n    justify-content: space-between;\n  }\n  \n  .carousel-btn.left {\n    border: none;\n    font-weight: 600;\n    padding: 0.5rem;\n    background-color: transparent;\n  }\n  \n  .carousel-btn.right {\n    border: none;\n    font-weight: 600;\n    padding: 0.5rem;\n    background-color: transparent;\n  }\n  \n  .carousel-btn:hover {\n    color: #E67817; \n  }\n  \n  .carousel-btn:focus {\n    outline: none; \n  }\n  \n  .group_tiger_revert_btn{\n    background-color: white;\n    padding: 0.5vh 0.4vw;\n    font-size: 0.7rem;\n    border-radius: 0.3vw;\n}\n\n\n/** Unidentified **/\n.unidentified-back{\n    font-size: 1.5rem;\n    font-weight: 900;\n    cursor: pointer;\n}\n.scrollable-container {\n  max-height: 80vh;\n  min-height: 70vh;\n  overflow-y: auto;\n  padding: 1rem;\n  position: relative;\n}\n\n.image-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 2vw;\n}\n\n.image-folder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 1rem;\n  background-color: #f9f9f9;\n  cursor: pointer;\n}\n\n.image-folder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 1rem;\n  background-color: #f9f9f9;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n}\n\n.image-folder:hover {\n  background-color: #FFF2E7;\n  border-color: #FF8214;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.folder-title {\n  margin-top: 0.5rem;\n  font-weight: bold;\n}\n\n.folder-count {\n  font-size: 0.85rem;\n  color: #666;\n}\n\n.loader-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 50vh;\n}\n\n.spinner {\n  border: 6px solid #f3f3f3;\n  border-top: 6px solid #FF8214;\n  border-radius: 50%;\n  width: 48px;\n  height: 48px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n\n.load-more-btn {\n  background-color: #FF8214;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 20px;\n  font-size: 0.8rem;\n  font-weight: bold;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: transform 0.2s ease, background-color 0.3s ease;\n}\n\n.load-more-btn:hover:not(:disabled) {\n  background-color: #e57110;\n  transform: scale(1.03);\n}\n\n.load-more-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
